/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreImageImageInput } from '../models/RestoreImageImageInput';
import { RestoreImageVolumeInput } from '../models/RestoreImageVolumeInput';

export class RestoreImageInput {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  /**
  * The region to restore the instance to
  */
  'region': string;
  /**
  * The image name to create from the instance
  */
  'name': string;
  /**
  * Optional description of the output image
  */
  'description'?: string;
  /**
  * Optional tags to apply to the output image and intermediate resources
  */
  'tags': { [key: string]: string; };
  'image'?: RestoreImageImageInput;
  'volumeSettings': Array<RestoreImageVolumeInput>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "image",
      "baseName": "image",
      "type": "RestoreImageImageInput",
      "format": ""
    },
    {
      "name": "volumeSettings",
      "baseName": "volumeSettings",
      "type": "Array<RestoreImageVolumeInput>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreImageInput.attributeTypeMap;
  }

  public constructor() {
  }
}

